/* global $ */
import { AtlasKitThemeProvider } from '@atlaskit/theme';
import React, { useCallback, useEffect, useMemo, useRef } from 'react';
import { connect, useDispatch, useSelector } from 'react-redux';
import { getParticipantById, getSharedVideoParticipant, pinParticipant, isLocalParticipantModerator, setModeratorPin, SET_MODERATOR_PIN, getLocalParticipant, checkModeratorPinRateLimit } from '../../../base/participants';
import { Icon, IconShareVideo, IconMenuThumb, IconModeratorPin, IconUserPinned } from '../../../base/icons';
import { YOUTUBE_PLAYER_PARTICIPANT_NAME } from '../../../shared-video/constants';
import { translate } from '../../../base/i18n';
import { IS_CUSTOM_PARTICIPANT_EVERYONE, setCustomParticipantEveryone, setCustomParticipantVisible } from '../../../base/conference';
import { exitTileViewIfNeeded } from '../../../conference/filmStripViewManager';
import { LAYOUTS } from '../../../video-layout';
import { BaseIndicator } from '../../../base/react';
import { setLabelsVisible } from '../../../toolbox/actions.web';
import logger from '../../logger';
import { getPictureInPictureModeConfig } from '../../../base/config/functions.any';
import { getFirstName } from '../../../display-name';
import { truncateText } from '../../../base/environment/utils';
const visibleButton = new Set(interfaceConfig.TOOLBAR_BUTTONS);
function SharedVideoThumbnail({ t, _isCustomParticipantVisible, _isCustomParticipantEveryone, _isPersonModerator, _visibleButtons, conference, filmStripView, _isPictureInPictureEnabled, ownerId, localParticipant, sharedParticipantName }) {
    const sharedVideoParticipant = useSelector(getSharedVideoParticipant);
    const containerRef = useRef(null);
    const videoContainerRef = useRef(null);
    const contextMenuInitialized = useRef(false);
    const dispatch = useDispatch();
    // const fakeParticipants = getParticipantById((state: IReduxState) => state);
    const onClick = useCallback(() => {
        if (sharedVideoParticipant) {
            if (filmStripView !== LAYOUTS.TILE_VIEW) {
                dispatch(setCustomParticipantVisible(false));
                dispatch(pinParticipant(sharedVideoParticipant.id, false));
            }
            exitTileViewIfNeeded(dispatch, filmStripView);
            if (_isCustomParticipantVisible || _isCustomParticipantEveryone) {
                dispatch(setLabelsVisible(true));
            }
            else {
                dispatch(setLabelsVisible(false));
            }
        }
    }, [dispatch, sharedVideoParticipant, filmStripView, _isCustomParticipantVisible, _isCustomParticipantEveryone]);
    const displayLabel = useMemo(() => {
        const participantName = ownerId === (localParticipant === null || localParticipant === void 0 ? void 0 : localParticipant.id) ? 'You' : getFirstName(sharedParticipantName) || 'Moderator';
        const textlimit = window.innerWidth < 1024 || _isPictureInPictureEnabled ? 10 : 26;
        const translatedText = t('dialog.youtubeSharingUser', { displayName: participantName });
        const displayNameText = truncateText(translatedText, textlimit);
        return displayNameText;
    }, [sharedVideoParticipant === null || sharedVideoParticipant === void 0 ? void 0 : sharedVideoParticipant.name, _isPictureInPictureEnabled, sharedParticipantName, ownerId, localParticipant === null || localParticipant === void 0 ? void 0 : localParticipant.id]);
    const onModeratorPinClick = useCallback(() => {
        if (sharedVideoParticipant) {
            if (checkModeratorPinRateLimit(dispatch, t)) {
                return;
            }
            // dispatch(setCustomParticipantEveryone(!_isCustomParticipantEveryone));
            dispatch(pinParticipant(null, true));
            const myId = conference.myUserId();
            const isModeratorPinned = sharedVideoParticipant && sharedVideoParticipant.moderatorPin;
            const pinAction = isModeratorPinned ? 'unpin' : 'pin';
            dispatch(setModeratorPin(sharedVideoParticipant === null || sharedVideoParticipant === void 0 ? void 0 : sharedVideoParticipant.id));
            if (conference) {
                conference.sendMessage({
                    type: SET_MODERATOR_PIN,
                    participant_id: sharedVideoParticipant === null || sharedVideoParticipant === void 0 ? void 0 : sharedVideoParticipant.id,
                    senderId: myId,
                    action: pinAction
                });
            }
            if (_isCustomParticipantEveryone) {
                dispatch(setLabelsVisible(true));
            }
            else {
                dispatch(setLabelsVisible(false));
            }
        }
    }, [dispatch, _isCustomParticipantEveryone, sharedVideoParticipant === null || sharedVideoParticipant === void 0 ? void 0 : sharedVideoParticipant.id, conference, sharedVideoParticipant === null || sharedVideoParticipant === void 0 ? void 0 : sharedVideoParticipant.moderatorPin]);
    const _renderTopIndicators = useMemo(() => (React.createElement("div", null,
        React.createElement(AtlasKitThemeProvider, { mode: 'dark' },
            !_isCustomParticipantEveryone && (_isCustomParticipantVisible || (sharedVideoParticipant === null || sharedVideoParticipant === void 0 ? void 0 : sharedVideoParticipant.pinned)) && (React.createElement(BaseIndicator, { className: 'indicator show-inline', icon: IconUserPinned, iconClassName: 'indicatoricon pipstroke', iconSize: '12px', tooltipKey: t('videothumbnail.userispinned'), tooltipPosition: 'bottom-left' })),
            (_isCustomParticipantEveryone || (sharedVideoParticipant === null || sharedVideoParticipant === void 0 ? void 0 : sharedVideoParticipant.moderatorPin)) && (React.createElement(BaseIndicator, { className: 'indicator show-inline', icon: IconModeratorPin, iconClassName: 'indicatoricon pipstroke', iconSize: '12px', tooltipKey: t('videothumbnail.pinByModerator'), tooltipPosition: 'bottom-left' }))))), [_isCustomParticipantVisible, _isCustomParticipantEveryone, t, sharedVideoParticipant === null || sharedVideoParticipant === void 0 ? void 0 : sharedVideoParticipant.pinned, sharedVideoParticipant === null || sharedVideoParticipant === void 0 ? void 0 : sharedVideoParticipant.moderatorPin]);
    const content = useMemo(() => (React.createElement("div", { className: 'popupmenu__item_dialog' },
        _isPersonModerator && (_visibleButtons === null || _visibleButtons === void 0 ? void 0 : _visibleButtons.has('moderator-pin')) && (React.createElement("li", { className: 'popupmenu__item private_msg_box' },
            React.createElement("button", { className: 'popupmenu__link', onClick: onModeratorPinClick },
                React.createElement("span", { className: 'popupmenu__icon' },
                    React.createElement(Icon, { src: IconModeratorPin })),
                React.createElement("span", { className: 'popupmenu__text' }, (_isCustomParticipantEveryone || (sharedVideoParticipant === null || sharedVideoParticipant === void 0 ? void 0 : sharedVideoParticipant.moderatorPin))
                    ? t('videothumbnail.unpinEveryone').toString() : t('videothumbnail.pinEveryone').toString())))),
        (_visibleButtons === null || _visibleButtons === void 0 ? void 0 : _visibleButtons.has('pin-user')) && React.createElement("li", { className: 'popupmenu__item private_msg_box' },
            React.createElement("button", { className: 'popupmenu__link', onClick: onClick },
                React.createElement("span", { className: 'popupmenu__icon' },
                    React.createElement(Icon, { src: IconUserPinned })),
                React.createElement("span", { className: 'popupmenu__text' }, (_isCustomParticipantVisible || (sharedVideoParticipant === null || sharedVideoParticipant === void 0 ? void 0 : sharedVideoParticipant.pinned)) ? t('videothumbnail.unpinMe').toString() : t('videothumbnail.pinMe').toString()))))), [_isPersonModerator, _visibleButtons, _isCustomParticipantEveryone, _isCustomParticipantVisible, onClick, onModeratorPinClick, t, sharedVideoParticipant === null || sharedVideoParticipant === void 0 ? void 0 : sharedVideoParticipant.pinned, sharedVideoParticipant === null || sharedVideoParticipant === void 0 ? void 0 : sharedVideoParticipant.moderatorPin]);
    // Build and initialize jQuery contextMenu
    useEffect(() => {
        if (!sharedVideoParticipant) {
            return;
        }
        const selector = '#sharedVideoThumbnailContainer';
        // Destroy existing context menu before recreating
        if (contextMenuInitialized.current) {
            try {
                $.contextMenu('destroy', selector);
            }
            catch (e) {
                // Ignore errors when destroying
            }
        }
        // Build context menu items
        const contextMenuItems = {};
        // Add Pin/Unpin option
        if (_visibleButtons === null || _visibleButtons === void 0 ? void 0 : _visibleButtons.has('pin-user')) {
            contextMenuItems.pin = {
                name: _isCustomParticipantVisible ? t('videothumbnail.unpinMe') : t('videothumbnail.pinMe'),
                callback: () => {
                    if (filmStripView !== LAYOUTS.TILE_VIEW) {
                        dispatch(setCustomParticipantVisible(!_isCustomParticipantVisible));
                    }
                    dispatch(pinParticipant(sharedVideoParticipant.id || null, false));
                    exitTileViewIfNeeded(dispatch, filmStripView);
                    if (_isCustomParticipantVisible || _isCustomParticipantEveryone) {
                        dispatch(setLabelsVisible(true));
                    }
                    else {
                        dispatch(setLabelsVisible(false));
                    }
                }
            };
        }
        // Add Pin Everyone option (only for moderators)
        if (_isPersonModerator && (_visibleButtons === null || _visibleButtons === void 0 ? void 0 : _visibleButtons.has('moderator-pin'))) {
            contextMenuItems.pinEveryone = {
                name: _isCustomParticipantEveryone ? t('videothumbnail.unpinEveryone') : t('videothumbnail.pinEveryone'),
                callback: () => {
                    dispatch(setCustomParticipantEveryone(!_isCustomParticipantEveryone));
                    dispatch(pinParticipant(null, true));
                    if (conference) {
                        const myId = conference.myUserId();
                        conference.sendMessage({
                            type: IS_CUSTOM_PARTICIPANT_EVERYONE,
                            action: !_isCustomParticipantEveryone,
                            senderId: myId
                        });
                    }
                    if (_isCustomParticipantEveryone) {
                        dispatch(setLabelsVisible(true));
                    }
                    else {
                        dispatch(setLabelsVisible(false));
                    }
                }
            };
        }
        // Initialize jQuery contextMenu
        $.contextMenu({
            selector,
            zIndex: 10000,
            items: contextMenuItems,
            events: {
                show(options) {
                    // Update pin text based on current state
                    if (options.items.pin) {
                        options.items.pin.name = t((_isCustomParticipantVisible || (sharedVideoParticipant === null || sharedVideoParticipant === void 0 ? void 0 : sharedVideoParticipant.pinned)) ? 'videothumbnail.unpinMe' : 'videothumbnail.pinMe');
                    }
                    // Update pin everyone text
                    if (options.items.pinEveryone) {
                        options.items.pinEveryone.name = t((_isCustomParticipantEveryone || (sharedVideoParticipant === null || sharedVideoParticipant === void 0 ? void 0 : sharedVideoParticipant.moderatorPin)) ? 'videothumbnail.unpinEveryone' : 'videothumbnail.pinEveryone');
                    }
                }
            }
        });
        contextMenuInitialized.current = true;
        // Cleanup function
        return () => {
            if (contextMenuInitialized.current) {
                try {
                    $.contextMenu('destroy', selector);
                    contextMenuInitialized.current = false;
                }
                catch (e) {
                    // Ignore errors when destroying
                }
            }
        };
    }, [
        sharedVideoParticipant,
        _isCustomParticipantVisible,
        _isCustomParticipantEveryone,
        _isPersonModerator,
        _visibleButtons,
        conference,
        filmStripView,
        dispatch,
        t,
        sharedVideoParticipant === null || sharedVideoParticipant === void 0 ? void 0 : sharedVideoParticipant.pinned,
        sharedVideoParticipant === null || sharedVideoParticipant === void 0 ? void 0 : sharedVideoParticipant.moderatorPin
    ]);
    if (!sharedVideoParticipant) {
        logger.log('No shared video participant found', sharedVideoParticipant);
        return null;
    }
    const isPinned = sharedVideoParticipant.pinned || sharedVideoParticipant.moderatorPin || _isCustomParticipantVisible || _isCustomParticipantEveryone || false;
    const isYouTube = sharedVideoParticipant.name === YOUTUBE_PLAYER_PARTICIPANT_NAME;
    // For YouTube videos, use the participant ID (which is the YouTube video ID) to construct thumbnail URL
    // This matches the pattern used in Thumbnail.js for rendering fake participants
    const thumbnailUrl = isYouTube
        ? `https://img.youtube.com/vi/${sharedVideoParticipant.id}/0.jpg`
        : null;
    return (React.createElement("div", { className: 'filmstrip__videos', id: 'sharedVideoThumbnailContainer', onClick: onClick, ref: containerRef },
        React.createElement("div", { className: `shared-thumbnail videocontainer ${isPinned ? 'videoContainerFocused' : ''}`, ref: videoContainerRef },
            React.createElement("div", { className: 'videocontainer__background' }),
            React.createElement("div", { className: 'videocontainer__toptoolbar' }, _renderTopIndicators),
            thumbnailUrl ? (React.createElement("img", { className: 'sharedVideoAvatar', src: thumbnailUrl, alt: sharedVideoParticipant.name })) : (React.createElement("div", { className: 'avatar-container-custom-participnt' },
                React.createElement(Icon, { size: 50, src: IconShareVideo }))),
            React.createElement("div", { className: 'displayNameMainContainer' },
                React.createElement("div", { className: 'displayNameContainer' },
                    React.createElement("span", { className: 'displayName' }, displayLabel))),
            React.createElement("span", { className: 'custom-participnt-dialog-parent' },
                React.createElement("span", { className: 'custom-participnt-parent' },
                    React.createElement(Icon, { size: '20', src: IconMenuThumb })),
                React.createElement("div", { className: 'custom-participnt-dialog' }, content)))));
}
/**
 * Maps (parts of) the Redux state to the associated SharedVideoThumbnail props.
 * @param {*} state - The Redux state.
 * @returns {Props}
 */
function mapStateToProps(state) {
    var _a;
    const { isCustomParticipantVisible, filmStripView, conference, isCustomParticipantEveryone } = state['features/base/conference'];
    const isPictureInPictureEnabled = getPictureInPictureModeConfig(state);
    const { ownerId } = state['features/shared-video'];
    const localParticipant = getLocalParticipant(state);
    const sharedParticipantName = ownerId ? (_a = getParticipantById(state, ownerId)) === null || _a === void 0 ? void 0 : _a.name : 'Guest';
    return {
        _isCustomParticipantVisible: isCustomParticipantVisible,
        _isCustomParticipantEveryone: isCustomParticipantEveryone,
        _isPersonModerator: isLocalParticipantModerator(state),
        _visibleButtons: visibleButton,
        filmStripView,
        conference,
        _isPictureInPictureEnabled: isPictureInPictureEnabled,
        ownerId,
        localParticipant,
        sharedParticipantName
    };
}
export default connect(mapStateToProps)(translate(SharedVideoThumbnail));
